import Manager from "./classes/Manager";

export const manager = new Manager();
